import { types } from 'actions/admin_template_fields'
import { createReducer } from '@reduxjs/toolkit'
import { orderBy, mapValues } from 'lodash'

const initialUpdatePositions = (fields) => {
  const mapped = mapValues(fields, (v, k) => ({ key: k, position: v.position }))
  const sorted = orderBy(mapped, 'position')
  const updatedFields = { ...fields }
  
  sorted.forEach((f, idx) => {
    updatedFields[f.key] = { ...updatedFields[f.key], position: idx }
  })

  return updatedFields
}

const initialState = {
  masterList: [],
  fieldsOptions: {},
  fields: {},
  translations: {}
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(types.INIT_FIELDS, (state, action) => {
      const { masterList, fieldsOptions, fields, translations } = action
      state.masterList = masterList || []
      state.fieldsOptions = fieldsOptions || {}
      state.fields = initialUpdatePositions(fields || {})
      state.translations = translations || {}
    })
    .addCase(types.ADD_FIELDS, (state, action) => {
      const currentFieldsCount = Object.keys(state.fields).length
      const fieldValues = action.fieldNames.map(f => f.value)
      
      // Add new fields
      action.fieldNames.forEach((fieldData, index) => {
        state.fields[fieldData.value] = {
          caption: fieldData.label,
          default_value: '',
          label_override: '',
          editable: true,
          position: currentFieldsCount + index
        }
      })
      
      // Update master list - remove added fields
      state.masterList = state.masterList.filter(item => 
        !fieldValues.includes(item.value)
      )
    })
    .addCase(types.REMOVE_FIELD, (state, action) => {
      const fieldName = action.fieldName
      const fieldCaption = state.fieldsOptions[fieldName]?.caption || fieldName
      
      // Add back to master list
      state.masterList.push({
        value: fieldName,
        label: fieldCaption
      })
      
      // Remove the field
      delete state.fields[fieldName]
    })
    .addCase(types.CHANGE_FIELD_DATA, (state, action) => {
      const { fieldName, attrKey, value } = action
      if (state.fields[fieldName]) {
        state.fields[fieldName][attrKey] = value
      }
    })
    .addCase(types.MOVE_FIELD, (state, action) => {
      const { fieldName, position } = action
      
      // Get sorted field names by position
      const sortedFields = Object.entries(state.fields)
        .sort(([, a], [, b]) => a.position - b.position)
        .map(([name]) => name)
      
      // Remove the field from its current position
      const currentIndex = sortedFields.indexOf(fieldName)
      if (currentIndex !== -1) {
        sortedFields.splice(currentIndex, 1)
      }
      
      // Insert at new position
      sortedFields.splice(position, 0, fieldName)
      
      // Update positions
      sortedFields.forEach((name, index) => {
        state.fields[name].position = index
      })
    })
})
